module.exports = __webpack_public_path__ + "static/img/class_22.05e1bfb3.jpg";